import React, { useState } from 'react';
import axiosInstance from '../../services/axiosInstance';
import { Box, Typography, Divider, Button, Stack, Switch, TextField, Grid, FormControlLabel, Checkbox, InputAdornment } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { useOutletContext } from "react-router-dom";

export default function Security() {
  const dispatch = useDispatch();
  const { setOpenSideBar, openSideBar } = useOutletContext();
  const { profileData } = useSelector((state) => state.profile);
  const { pdfEditortoken } = useSelector((state) => state.pdfEditortoken);
  const [passwordchecked, setPasswordChecked] = useState(true);
  const [downloadchecked, setDownloadChecked] = useState(true);
  const [watermarchecked, setWatermarkChecked] = useState(false);
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({ password: "", percentage: "", expiredays: "" });
  const [helperText, setHelperText] = useState({ password: "", percentage: "", expiredays: "" });

  
  return (
    openSideBar && (
        <Stack sx={{ height: '100%', width: '80%' }}>
            <Box sx={{ height: '80px', display: "flex", alignItems:'center' }}>
                <Typography noWrap component="p" sx={{ fontSize: '20px', fontWeight: 600, lineHeight: '20px', color: "#1D1D1D", ml: 2 }}>
                    Security
                </Typography>
            </Box>
            <Divider sx={{ borderWidth : "1px" }} />
            <Box
            sx={{
                borderRadius: '12px',
                background: '#fff',
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column"
            }}
            >
                <Box sx={{ padding: "16px", display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%", }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, justifyContent: "space-between" }}>
                        <Typography textAlign="center" sx={{ fontSize: 16, fontWeight: 500, lineHeight: "24px" }}>
                            Password Protect
                        </Typography>
                        <Switch
                            checked={passwordchecked}
                            onChange={() => setPasswordChecked(!passwordchecked)}
                            sx={{
                                width: 35,
                                height: 22,
                                padding: 0,
                                "& .MuiSwitch-switchBase": {
                                    padding: '2px',
                                    transition: "all 0.3s ease",
                                    "&.Mui-checked": {
                                        transform: "translateX(13px)",
                                        color: "#fff",
                                        "& + .MuiSwitch-track": {
                                            backgroundColor: "#4caf50",
                                            opacity: 1,
                                        },
                                    },
                                },
                                "& .MuiSwitch-thumb": {
                                    width: 18,
                                    height: 18,
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                },
                                "& .MuiSwitch-track": {
                                    borderRadius: 13,
                                    backgroundColor: "#ccc",
                                    opacity: 1,
                                    transition: "all 0.3s ease",
                                },
                            }}
                        />
                    </Box>
                    { passwordchecked && (
                        <TextField
                            placeholder="Enter Password"
                            type="text"
                            variant="outlined"
                            fullWidth
                            value={password}
                            onChange={(e) => {
                            setPassword(e.target.value)
                            setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
                            setHelperText((prevHelperText) => ({ ...prevHelperText, password: "" }))
                        }}
                            error={!!errors.password}
                            sx={{
                            mt: 2,
                            boxSizing: "border-box",
                            borderRadius: "10px",
                            backgroundColor: "#fff",
                            borderColor: "#C0C0C0",
                            borderWidth: "5px",
                            "& .MuiOutlinedInput-root": {
                                borderColor: errors.password ? "#FF6666" : "#C0C0C0",
                                backgroundColor: errors.password ? "#FFF1F1" : "none",
                                "&:hover fieldset": {
                                borderColor: errors.password ? "#FF6666" : "#C0C0C0",
                                },
                                "&.Mui-focused fieldset": {
                                borderColor: errors.password ? "#FF6666" : "#C0C0C0",
                                },
                            },
                            "& .MuiFormHelperText-root": {
                                color: "#FF6666",
                            },
                            }}
                            InputProps={{
                            sx: { 
                                borderRadius: "10px",
                                height: 46,
                                fontSize: "14px",
                                fontWeight: "400",
                                "& input::-ms-reveal, & input::-ms-clear": {
                                    display: "none",
                                },
                            },
                            }}
                        />
                    )}
                    {!! errors.password && (
                        <Typography
                        sx={{
                            color: "#FF6666",
                            fontSize: "12px",
                            mt: 0.5,
                            mb: 0,
                            marginRight: "auto"
                        }}
                        >
                        {helperText.password}
                        </Typography>
                    )}


                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, justifyContent: "space-between", mt: 3 }}>
                        <Typography textAlign="center" sx={{ fontSize: 16, fontWeight: 500, lineHeight: "24px" }}>
                            Enable Download
                        </Typography>
                        <Switch
                            checked={downloadchecked}
                            onChange={() => setDownloadChecked(!downloadchecked)}
                            sx={{
                                width: 35,
                                height: 22,
                                padding: 0,
                                "& .MuiSwitch-switchBase": {
                                    padding: '2px',
                                    transition: "all 0.3s ease",
                                    "&.Mui-checked": {
                                        transform: "translateX(13px)",
                                        color: "#fff",
                                        "& + .MuiSwitch-track": {
                                            backgroundColor: "#4caf50",
                                            opacity: 1,
                                        },
                                    },
                                },
                                "& .MuiSwitch-thumb": {
                                    width: 18,
                                    height: 18,
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                },
                                "& .MuiSwitch-track": {
                                    borderRadius: 13,
                                    backgroundColor: "#ccc",
                                    opacity: 1,
                                    transition: "all 0.3s ease",
                                },
                            }}
                        />
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, justifyContent: "space-between", mt: 3 }}>
                        <Typography textAlign="center" sx={{ fontSize: 16, fontWeight: 500, lineHeight: "24px" }}>
                            Add Watermark
                        </Typography>
                        <Switch
                            checked={watermarchecked}
                            onChange={() => setWatermarkChecked(!watermarchecked)}
                            sx={{
                                width: 35,
                                height: 22,
                                padding: 0,
                                "& .MuiSwitch-switchBase": {
                                    padding: '2px',
                                    transition: "all 0.3s ease",
                                    "&.Mui-checked": {
                                        transform: "translateX(13px)",
                                        color: "#fff",
                                        "& + .MuiSwitch-track": {
                                            backgroundColor: "#4caf50",
                                            opacity: 1,
                                        },
                                    },
                                },
                                "& .MuiSwitch-thumb": {
                                    width: 18,
                                    height: 18,
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                },
                                "& .MuiSwitch-track": {
                                    borderRadius: 13,
                                    backgroundColor: "#ccc",
                                    opacity: 1,
                                    transition: "all 0.3s ease",
                                },
                            }}
                        />
                    </Box>

                    <Box sx={{ display: "flex", width: "100%", justifyContent: "space-between", mt: "auto" }}>
                        <Button variant="contained" sx={{ width: '126px', height: 46, color: "#185CB7", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "600",}} >
                            Save Draft
                        </Button>

                        <Button variant="contained" sx={{ width: '172px', height: 46, color: "#185CB7", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "600", 
                        "&:hover": { background: "#185CB7" }, 
                        "&.Mui-disabled": {
                        background: "#D8D8D8",
                        border: "1px solid #D8D8D8",
                        color: "#fff",
                        } }} disabled >
                            Review & Send
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Stack>
    )
  );
}
